import { render, staticRenderFns } from "./InstitutionSection.vue?vue&type=template&id=136af72a&"
import script from "./InstitutionSection.vue?vue&type=script&lang=js&"
export * from "./InstitutionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports